export default __webpack_public_path__ + "static/media/Due.2fd029b0.svg";